import axios from 'axios'
import { Message } from 'element-ui'
import { i18nConfig } from '.'

const baseURL = `${process.env.VUE_APP_REQUEST_URL}/`

const service = axios.create({
  baseURL,
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
    'content-type': 'application/json'
  },
  timeout: 1000000,
  method: 'post'
})

axios.defaults.withCredentials = true

service.interceptors.request.use(
  (config) => {
    config.data = JSON.parse(JSON.stringify(config.data || '{}'))

    if (config.data.current) {
      config.data.pageNo = config.data.current
      delete config.data.current
    }

    if (config.data.limit) {
      config.data.pageSize = config.data.limit
      delete config.data.limit
    }

    config.headers['X-Locale'] = config.locale || i18nConfig.defaultLocale

    return config
  },
  (error) => Promise.reject(error)
)

service.interceptors.response.use(
  (res) => res.data,
  (error) => {
    if (!error.response) {
      Message.error('无响应')
      return Promise.reject(error)
    }

    const errorMessage =
      error.response && error.response.data ? error.response.data.message : 'uncatch error'

    if (error.response.status === 401) {
      Message.error('用户未授权')

      localStorage.login = false
      window.location.reload()
    }

    Message.error(errorMessage)
    return Promise.reject(error)
  }
)

export default service
